import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=a65ce5e6&scoped=true&"
import script from "./couponList.vue?vue&type=script&lang=js&"
export * from "./couponList.vue?vue&type=script&lang=js&"
import style0 from "./couponList.vue?vue&type=style&index=0&id=a65ce5e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65ce5e6",
  null
  
)

export default component.exports